import WifiAmenityModal from "../../Components/User/Dashboard/WifiAmenityModal/WifiAmenityModal";
import {
  getGuestAmenityAccess,
  openGuestDoor,
} from "../../Redux/Bookings/BookingsActions";
import Loading from "../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import toastHelper from "../../Util/toastHelper";
import styles from "./GuestAccess.module.scss";
import WifiImage from "../../Assets/Wifi.gif";
import LockImage from "../../Assets/Lock.gif";
import { FaUnlockAlt } from "react-icons/fa";
import Error404 from "../Error404/Error404";
import Logo from "../../Assets/Logo.png";
import { useParams } from "react-router";
import moment from "moment";

function GuestAccess() {
  const { uuid } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const {
    guestAmenityAccessLoading,
    guestAmenityAccessError,
    guestAmenityAccessData,
    openGuestDoorLoading,
    openGuestDoorData,
  } = useSelector((state: RootState) => state.bookings);

  const [isWifiModalActive, setIsWifiModalActive] = useState(false);
  const [openDoorAmenityId, setOpenDoorAmenityId] = useState<number | null>(
    null,
  );
  const wifiHandler = () => {
    setIsWifiModalActive(true);
  };

  const openDoorHandler = (amenityId: number) => {
    if (amenityId) {
      if (!openGuestDoorLoading && !openGuestDoorData) {
        setOpenDoorAmenityId(amenityId);
        dispatch(
          openGuestDoor({
            amenityId: amenityId.toString(),
            guestUuid: uuid || "",
          }),
        );
      }
    } else {
      toastHelper.error("Amenity ID is required");
    }
  };

  useEffect(() => {
    if (uuid) {
      dispatch(
        getGuestAmenityAccess({
          guestUuid: uuid,
        }),
      );
    }
  }, [uuid, dispatch]);

  return (
    <React.Fragment>
      <WifiAmenityModal
        isOpen={isWifiModalActive}
        setIsOpen={setIsWifiModalActive}
      />
      {(guestAmenityAccessLoading || openGuestDoorLoading) && <Loading />}
      {guestAmenityAccessError && <Error404 />}
      {guestAmenityAccessData && (
        <div className={styles.mainContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.logoContainer}>
              <img src={Logo} alt="logo" className={styles.logo} />
            </div>
          </div>
          <div className={styles.amenitiesContainer}>
            <div className={styles.headingContainer}>
              <p>My Amenities</p>
            </div>
            <div className={styles.amenitiesList}>
              {guestAmenityAccessData?.amenities?.map(
                (amenity: any, i: number) => {
                  if (amenity?.amenityTypeName === "Wifi") {
                    return (
                      <div
                        className={styles.amenity}
                        key={i}
                        onClick={wifiHandler}
                      >
                        <div className={styles.lockImageContainer}>
                          <img
                            className={styles.lockImage}
                            src={WifiImage}
                            alt="Wifi"
                          />
                        </div>
                        <div className={styles.imageContainer}>
                          <img
                            className={styles.image}
                            width={100}
                            height={100}
                            src={amenity?.image}
                            alt=""
                          />
                        </div>
                        <div className={styles.infoMainContainer}>
                          <div className={styles.infoContainer}>
                            <p className={styles.name}>{amenity?.name}</p>
                            <p className={styles.lastVisited}>
                              Last Visit{" "}
                              {amenity?.lastVisited
                                ? moment(amenity?.lastVisited).format(
                                    "MM/DD/YYYY",
                                  )
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return (
                    <div
                      className={styles.amenity}
                      key={i}
                      onClick={() => openDoorHandler(amenity?.amenityId)}
                    >
                      <div className={styles.lockImageContainer}>
                        <img
                          className={styles.lockImage}
                          src={LockImage}
                          alt="Lock"
                        />
                      </div>
                      <div className={styles.imageContainer}>
                        <img
                          className={styles.image}
                          width={100}
                          height={100}
                          src={amenity?.image}
                          alt=""
                        />
                      </div>
                      <div className={styles.infoMainContainer}>
                        <div className={styles.infoContainer}>
                          <p className={styles.name}>{amenity?.name}</p>
                          <p className={styles.lastVisited}>
                            Last Visit{" "}
                            {amenity?.lastVisited
                              ? moment(amenity?.lastVisited).format(
                                  "MM/DD/YYYY",
                                )
                              : "N/A"}
                          </p>
                        </div>
                        <div className={styles.openDoorContainer}>
                          {openGuestDoorData &&
                          openDoorAmenityId === amenity?.amenityId ? (
                            <FaUnlockAlt className={styles.icon} />
                          ) : (
                            <FaUnlockAlt className={styles.icon} />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default GuestAccess;
